<template>
	<div class="vip-view-container">
		<SentimentDayTiming title="周期择时" subText="节点把控-看图1" modal="0" :bottom-section-mask="true"></SentimentDayTiming>
	</div>
</template>

<script>
	import SentimentDayTiming from 'components/sentiment/SentimentDayTiming.vue'
	
	export default {
		components: {
			SentimentDayTiming
		}
	}
</script>

<style scoped>
.vip-view-container {
	padding: 0px;
	background: var(--bg-main, #060710);
	min-height: 100vh;
}
</style>
